export const STACK = [
  { k: '01 · Language', v: '<em>TypeScript</em>' },
  { k: '02 · Language', v: 'JavaScript' },
  { k: '03 · UI', v: '<em>React</em>' },
  { k: '04 · UI', v: 'Vue' },
  { k: '05 · Meta', v: 'Next.js' },
  { k: '06 · Runtime', v: 'Node.js' },
  { k: '07 · Backend', v: '<em>NestJS</em>' },
  { k: '08 · Data', v: 'PostgreSQL' },
  { k: '09 · Data', v: 'SQL · Prisma' },
  { k: '10 · AI', v: 'OpenAI · LLMs' },
  { k: '11 · Infra', v: 'Docker · CI' },
  { k: '12 · Test', v: 'Vitest · Playwright' },
];